<div id="landing-av-footer" class="bg-primary-800 primary-50 pt-4 pt-lg-5">
    <div class="container">
        <div class="row align-items-end">
            <div class="col-lg-5 col-xl-6 mb-3 mb-lg-0">
                <span class="p1-regular border-bottom-4 border-secondary-creative-500 pb-2">
                    <strong class="p1-bold">SEGO Creative</strong>
                </span>
                <p class="p2-medium mt-4 mb-1">
                    <a href="mailto:info@segofinance.com" title="info@segofinance.com" target="_blank"
                        class="link2-medium primary-50 link-footer-creative">
                        info&#64;segofinance.com
                    </a> | +34 91 534 66 98
                </p>
            </div>
            <div class="col-lg-7 col-xl-6">
                <div class="d-lg-flex justify-content-lg-between">
                    <div class="mb-3 mb-lg-0">
                        <a [routerLink]="['/creative/registro']" target="_blank" title="Registra tu proyecto"
                            class="link3-semibold primary-50 px-lg-2 link-footer-creative">Registra tu proyecto</a>
                    </div>
                    <div class="mb-3 mb-lg-0">
                        <a [routerLink]="['/legal/segofinance/politica-de-privacidad']" target="_blank"
                            title="Política de privacidad"
                            class="link3-semibold primary-50 px-lg-2 link-footer-creative">Política de privacidad</a>
                    </div>
                    <div class="mb-3 mb-lg-0">
                        <a [routerLink]="['/legal/segofinance/politica-de-cookies']" target="_blank"
                            title="Política de cookes"
                            class="link3-semibold primary-50 px-lg-2 link-footer-creative">Política de cookies</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row align-items-start my-3 my-lg-4 py-1 pt-lg-2">
            <div class="col-lg-3 mb-4 mb-lg-0">
                <!-- Botón de ajustes de cookies de CookiePro (inicio) -->
                <button id="ot-sdk-btn"
                    class="ot-sdk-show-settings landing-creative mb-1 mb-lg-0 font-primary font-size-14 font-weight-600 line-height-24"
                    title="Configuración de las cookies">
                    <span class="primary-50">Configuración cookies</span>
                </button>
                <!-- Botón de ajustes de cookies de CookiePro (fin) -->
            </div>
            <div class="col-lg-9">
                <p class="p3-regular mb-0 font-weight-400">
                    <strong class="p3-bold">SEGO Creative</strong> son productos ofrecidos por <strong class="p3-bold">SociosInversores 2010
                        SL</strong>, sociedad del grupo SegoFinance y Proveedor de Servicios de Financiación
                    Participativa, <a
                        href='https://www.cnmv.es/portal/Consultas/Servicios-Financiacion-Participativa/Listado-Proveedores.aspx'
                        target='_blank'
                        class='link3-semibold primary-100 link-footer-creative'
                        title='Comisión Nacional del Mercado de Valores (CNMV)'>supervisado por CNMV</a> y registrado en
                    la Autoridad Europea de Supervisión de Valores y Mercados (AEVM) con Licencia nº 7. Sujeto al
                    Reglamento (UE) 2020/1503 del Parlamento Europeo.
                </p>
            </div>
        </div>
    </div>
    <div class="border-bottom-1 border-primary-400"></div>
    <div class="container py-3">
        <div class="row align-items-center">
            <div class="col-12 text-center text-lg-end">
                <p class="p3-medium">© {{yearCopyright}} Grupo SEGOFINANCE. Todos los derechos reservados</p>
            </div>
        </div>
    </div>
</div>